export interface ITriggerStore extends ITriggerBody {
  hashCode: number;
}

export interface ITriggerBody {
  temp?: {
    value: number
    operator: TriggerOperator,
    enabled: boolean
  };
  humid?: {
    value: number,
    operator: TriggerOperator,
    enabled: boolean
  };
  co2?: {
    value: number,
    operator?: TriggerOperator,
    enabled: boolean
  };
  voc?: {
    value: number,
    operator?: TriggerOperator,
    enabled: boolean
  };
  dust?: {
    value: number,
    operator?: TriggerOperator,
    enabled: boolean
  };
  pm25?: {
    value: number,
    operator?: TriggerOperator,
    enabled: boolean
  };
  pm10?: {
    value: number,
    operator?: TriggerOperator,
    enabled: boolean
  };
}

export enum TriggerOperator {
  Greater = 'greater',
  Less = 'less'
}
